import salesrepConfig from "emun.salesrep/salesrep.config";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";

class SalesRepGroupDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this);
    var map = this;
    var percent = 0;
    let $ctrl = this;
    $ctrl.bus = new ServiceBus();
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.chartLoaded = false;
    $ctrl.productImage = $appConfig.productImage;
    let options = {
      url: "QuerySalesReps.json?IncludeSalesData=true&Id=" + $ctrl.repId,
      pageSize: 15,
      orderBy: "Name",
      autoLoad: true,
      append: false,
      onLoaded: function (args) {
        $ctrl.rep = args.first;
        $ctrl.$state.current.customTitle = $ctrl.rep.name;
      },
    };
    $ctrl.goals = {
      month: 0,
      monthPercent: 0,
      quarter: 0,
      quarterPercent: 0,
      year: 0,
      yearPercent: 0,
    };
    $ctrl.dailySales = {
      total: 0,
      count: 0,
    };
    $ctrl.yesterdaySales = {
      total: 0,
      count: 0,
    };
    $ctrl.weekSales = {
      total: 0,
      count: 0,
    };
    $ctrl.lastweekSales = {
      total: 0,
      count: 0,
    };
    $ctrl.quarterSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastquarterSales = {
      total: 0,
      count: 0,
    };
    $ctrl.ytdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastytdSales = {
      total: 0,
      count: 0,
    };
    $ctrl.mtdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastmtdSales = {
      total: 0,
      count: 0,
    };

		$ctrl.todayTotal = new AutoQuery({
			url:
				`QueryCartsJoin.json?StatusIn=Open,Completed,Review&Sum=GrandTotal&GroupBy=OrderedOn&SalesRepId=${$ctrl.repId}`,
			autoLoad: true,
			criteria: {
				OrderedOn: moment().format("l"),
				clientDateTime: moment().format("MM/DD/YYYY H:m:s Z")
				//dateRange: 'Today'
			},
			scrollTop: false,
			disableQueryString: true,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.dailySales.total += res.sumGrandTotal;
					});
				}
			}
		});

		$ctrl.todayTotalCount = new AutoQuery({
			url:
				`QueryCartsJoin.json?StatusIn=Open,Completed,Review&Count=Id&GroupBy=OrderedOn&SalesRepId=${$ctrl.repId}`,
			autoLoad: true,
			criteria: {
				OrderedOn: moment().format("l"),
				clientDateTime: moment().format("MM/DD/YYYY H:m:s Z")
				//dateRange: 'Today'
			},
			scrollTop: false,
			disableQueryString: true,
			onLoaded: function (args) {
				if (args.total > 0 && args.results) {
					$ctrl.dailySales.count = args.results[0].Total;
				}
			}
		});

    $ctrl.query = createAutoQuery(options);
    $ctrl.dailySalesQuery = createAutoQuery({
      url:
        "QuerySalesYOYTotals.json?Sum=TotalSalesToday,TotalSalesCountToday,TotalSalesYesterday,TotalSalesCountYesterday,TotalSalesWeekToDate,TotalSalesCountWeekToDate,TotalSalesQuarterToDate,TotalSalesCountQuarterToDate,TotalSalesQuarterToDateLastYear,TotalSalesCountQuarterToDateLastYear,TotalSalesYearToDate,TotalSalesCountYearToDate,TotalSalesYearToDateLastYear,TotalSalesCountYearToDateLastYear,TotalSalesMonthToDate,TotalSalesCountMonthToDate,TotalSalesMonthToDateLastYear,TotalSalesCountMonthToDateLastYear&GroupBy=SalesRepID&salesrepId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          var res = args.first;
          // $ctrl.dailySales.total = res.sumTotalSalesToday;
          // $ctrl.dailySales.count = res.sumTotalSalesCountToday;
          $ctrl.yesterdaySales.total = res.sumTotalSalesYesterday;
          $ctrl.yesterdaySales.count = res.sumTotalSalesCountYesterday;
          $ctrl.weekSales.total = res.sumTotalSalesWeekToDate;
          $ctrl.weekSales.count = res.sumTotalSalesCountWeekToDate;
          $ctrl.quarterSales.total += res.sumTotalSalesQuarterToDate;
          $ctrl.quarterSales.count += res.sumTotalSalesCountQuarterToDate;
          $ctrl.lastquarterSales.total +=
            res.sumTotalSalesQuarterToDateLastYear;
          $ctrl.lastquarterSales.count +=
            res.sumTotalSalesCountQuarterToDateLastYear;
          var percent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) * 100
          );
          if ($ctrl.lastquarterSales.total == 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.quarterSales.percent = 100 - percent;
            $ctrl.quarterSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.quarterSales.percent = percent - 100;
            $ctrl.quarterSales.trend = "up";
          } else {
            $ctrl.quarterSales.percent = 100;
            $ctrl.quarterSales.trend = "neutral";
          }
          $ctrl.ytdSales.total += res.sumTotalSalesYearToDate;
          $ctrl.ytdSales.count += res.sumTotalSalesCountYearToDate;
          $ctrl.lastytdSales.total += res.sumTotalSalesYearToDateLastYear;
          $ctrl.lastytdSales.count += res.sumTotalSalesCountYearToDateLastYear;
          percent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100
          );
          if ($ctrl.lastytdSales.total == 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.ytdSales.percent = 100 - percent;
            $ctrl.ytdSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.ytdSales.percent = percent - 100;
            $ctrl.ytdSales.trend = "up";
          } else {
            $ctrl.ytdSales.percent = 100;
            $ctrl.ytdSales.trend = "neutral";
          }
          $ctrl.mtdSales.total += res.sumTotalSalesMonthToDate;
          $ctrl.mtdSales.count += res.sumTotalSalesCountMonthToDate;
          $ctrl.lastmtdSales.total += res.sumTotalSalesMonthToDateLastYear;
          $ctrl.lastmtdSales.count += res.sumTotalSalesCountMonthToDateLastYear;
          percent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.lastmtdSales.total) * 100
          );
          if ($ctrl.lastmtdSales.total == 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.mtdSales.percent = 100 - percent;
            $ctrl.mtdSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.mtdSales.percent = percent - 100;
            $ctrl.mtdSales.trend = "up";
          } else {
            $ctrl.mtdSales.percent = 100;
            $ctrl.mtdSales.trend = "neutral";
          }
        }
      },
    });
    $ctrl.lastweekSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=LastWeek&Sum=OrderTotal&Count=OrderTotal&GroupBy=SalesRepID&salesrepId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          $ctrl.lastweekSales.total = Math.round(args.first.sumOrderTotal);
          $ctrl.lastweekSales.count = args.first.countOrderTotal;
        }
      },
    });
    $ctrl.goalsQuery = createAutoQuery({
      url:
        "QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&GroupBy=vendorID&SalesRepID=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.goals.month += res.sumSalesGoalThisMonth;
            $ctrl.goals.quarter += res.sumSalesGoalThisQuarter;
            $ctrl.goals.year += res.sumSalesGoalThisYear;
          });
          $ctrl.goals.monthPercent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.goals.month) * 100
          );
          $ctrl.goals.quarterPercent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
          );
          $ctrl.goals.yearPercent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
          );
        }
      },
    });
    $ctrl.openOrders = createAutoQuery({
      url: "QueryCarts.json?StatusNotEqualTo=Cart&salesrepid=" + $ctrl.repId,
      orderBy: "-OrderedOn",
      autoLoad: true,
      pageSize: 10,
    });
    $ctrl.$session = $session;
    $ctrl.markets = [];
    $ctrl.showCodesQuery = createAutoQuery({
      url: "QueryMarketDates.json",
      autoLoad: true,
      take: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (market) {
          if (
            $ctrl.markets.filter(
              (m) => m.market === market.market && m.year === market.year
            ).length === 0
          ) {
            market.visible = true;
            $ctrl.markets.push(market);
          }
        });
      },
    });
    $ctrl.lastSyncDate = "";
    $ctrl.lastSyncDuration = "";
    this.lastSyncDateQuery = createAutoQuery({
      url: "querysynchistorysummary?UserId=" + $ctrl.repId,
      pageSize: 1000,
      autoLoad: true,
      onLoaded: function (args) {
        if (args.total > 0) {
          $ctrl.lastSyncDate = args.results[0].syncStart || "";
          $ctrl.lastSyncDuration = args.results[0].syncTime || "";
        }
      },
    });

    this.uniqueCustomersBooked = 0;
    this.newAccountsBooked = 0;
    this.newAccountsBookedYTD = 0;
    this.storeVisits = 0;
    this.avgAppointment = 0;

    var timezone = moment.tz.guess();
    this.currentDate = moment.tz(timezone).format("DD/MM/YYYY");

    this.query = createAutoQuery(options);

    this.uniqueCustomersBooked = 0;
    this.uniqueCustomersBookedQuery = new AutoQuery({
      url: "QuerySalesDailyCustomerTotals.json",
      autoLoad: true,
      criteria: {
        SourceContains: $ctrl.salesrepConfig.roadSources
          ? $ctrl.salesrepConfig.roadSources
          : "Road",
        dateRange: "Week",
        CountDistinct: "CustomerId",
        GroupBy: "SalesRepID",
        SalesRepID: $ctrl.repId,
      },
      pageSize: 1000,
      onLoaded: (args) => {
        if (args.total > 0) {
          args.results.forEach(function (total) {
            $ctrl.uniqueCustomersBooked += total.countDistinctCustomerId;
          });
        }
      },
    });

    this.bookingsThisWeek = 0;
    this.bookingsYTD = 0;
    this.bookingsLYTD = 0;
    this.roadBookings = createAutoQuery({
      url: "QuerySalesYOYTotals.json",
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        SourceContains: $ctrl.salesrepConfig.roadSources
          ? $ctrl.salesrepConfig.roadSources
          : "Road",
        currentDate: this.currentDate,
        Sum: "TotalSalesWeekToDate,TotalSalesYearToDate,TotalSalesYearToDateLastYear",
        GroupBy: "VendorId",
        SalesRepID: $ctrl.repId,
      },
      onLoaded: function (totals) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        totals.results.forEach(function (total) {
          $ctrl.bookingsThisWeek += total.sumTotalSalesWeekToDate;
        });
      },
    });

    var startWeek = moment().startOf("week").format("MM/DD/YYYY");
    this.newAccountsBookedWTDQuery = createAutoQuery({
      url: "QuerySalesDailyCustomerTotals.json",
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        SourceContains: $ctrl.salesrepConfig.roadSources
          ? $ctrl.salesrepConfig.roadSources
          : "Road",
        currentDate: this.currentDate,
        dateRange: "WTD",
        CountDistinct: "CustomerId",
        SinceCreatedDate: startWeek,
        GroupBy: "SalesRepID",
        SalesRepID: $ctrl.repId,
      },
      onLoaded: (args) => {
        if (args.total > 0) {
          args.results.forEach(function (total) {
            $ctrl.newAccountsBooked += total.countDistinctCustomerId;
          });
        }
      },
    });

    this.storeVisitsQuery = createAutoQuery({
      url:
        "QueryActivitiesJoin.json?repid=" +
        this.repId +
        "&typeIn=Firm%20Appointment,Cold%20Call,Firm%20Appointment-P,Cold%20Call-P&dateRange=Week&Count=Id&GroupBy=username",
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate,
      },
      onLoaded: (args) => {
        if (args.total > 0) {
          this.storeVisits = Math.round(args.first.Total);
        }
      },
    });

    this.bookingsThisWeek = 0;
    this.roadBookings = createAutoQuery({
      url:
        "QuerySalesYOYTotals.json?SourceContains=Road&Sum=TotalSalesWeekToDate,TotalSalesYearToDate,TotalSalesYearToDateLastYear&GroupBy=VendorId&SalesRepID=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate,
      },
      onLoaded: function (totals) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        totals.results.forEach(function (total) {
          $ctrl.bookingsThisWeek += total.sumTotalSalesWeekToDate;
        });
      },
    });
    this.totalBookings = createAutoQuery({
      url:
        "QuerySalesYOYTotals.json?Sum=TotalSalesWeekToDate,TotalSalesYearToDate,TotalSalesYearToDateLastYear&GroupBy=VendorId&SalesRepID=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate,
      },
      onLoaded: function (totals) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        $ctrl.bookingsYTD = 0;
        $ctrl.bookingsLYTD = 0;
        totals.results.forEach(function (total) {
          $ctrl.bookingsYTD += total.sumTotalSalesYearToDate;
          $ctrl.bookingsLYTD += total.sumTotalSalesYearToDateLastYear;
        });
      },
    });

    var startWeek = moment().startOf("week").format("MM/DD/YYYY");
    this.newAccountsBookedWTDQuery = createAutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?SourceContains=Road&dateRange=WTD&CountDistinct=CustomerId&SinceCreatedDate=" +
        startWeek +
        "&GroupBy=SalesRepID&SalesRepID=" +
        $ctrl.repId,
      //            url: 'QueryOrderLinesJoinTwos.json?dateRange=WTD&TwosSalesOrderCustom5=1&SinceRetailerCreatedOn=' + startWeek + '&CountDistinct=RetailerId&GroupBy=SalesRepID&RetailerSalesRep1=' + $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate,
      },
      onLoaded: (args) => {
        if (args.total > 0) {
          args.results.forEach(function (total) {
            $ctrl.newAccountsBooked += total.countDistinctCustomerId;
          });
        }
      },
    });

    var startYear = moment().startOf("year").format("MM/DD/YYYY");
    this.newAccountsBookedYTDQuery = createAutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?dateRange=YTD&CountDistinct=CustomerId&SinceCreatedDate=" +
        startYear +
        "&GroupBy=SalesRepID&SalesRepID=" +
        $ctrl.repId,
      //url: 'QueryOrderLinesJoinTwos.json?dateRange=YTD&SinceRetailerCreatedOn=' + startYear + '&CountDistinct=RetailerId&GroupBy=SalesRepID&RetailerSalesRep1=' + $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: (args) => {
        if (args.total > 0) {
          args.results.forEach(function (total) {
            $ctrl.newAccountsBookedYTD += total.countDistinctCustomerId;
          });
        }
      },
    });

		$ctrl.totalOpenOrders = 0;
		this.openOrdersQuery = createAutoQuery({
			url: 'QueryCartItemsJoin.json?Sum=OpenTotal&CartItemActvive=true&IsActvive=true&CartItemStatus=Open&Status=Open&GroupBy=SalesRepId&SalesRepId=' + $ctrl.repId,
			pageSize: 1000,
			autoLoad: true,
			onLoaded: function (totals) {
				$ctrl.chartLabels = [];
				$ctrl.chartData = [];
				totals.results.forEach(function (total) {
					$ctrl.totalOpenOrders += total.sumOpenTotal;
				});
			}
		});

		$ctrl.onholdTotal = 0;
		$ctrl.onholdCount = 0;
		$ctrl.pendingTotal = 0;
		$ctrl.pendingCount = 0;
		this.onHoldOrdersQuery = createAutoQuery({
			url: 'QueryOrdersJoin.json?Sum=GrandTotal&CountDistinct=CartId&Status=On Hold&Exported=0&GroupBy=SalesRepId&SalesRepId=' + $ctrl.repId,
			pageSize: 1000,
			autoLoad: true,
			onLoaded: function (totals) {
				$ctrl.chartLabels = [];
				$ctrl.chartData = [];
				totals.results.forEach(function (total) {
					$ctrl.onholdTotal += total.sumGrandTotal || 0;
					$ctrl.onholdCount += total.countDistinctCartId || 0;
				});
			}
		});


	}
	$onInit() {
		const $ctrl = this;
		/*
			setTimeout(function () {
			  window.scrollTo(0,0);
			}, 3000);
		*/
  }
  load() {
    return $ctrl.query.load.apply($ctrl.query, arguments);
  }
  runReport(name) {
    const $ctrl = this;
    let url = $appConfig.resolveServiceUrl(name + "?salesrepid=" + $ctrl.repId);
    return (location.href = url);
  }
}

export default SalesRepGroupDashboardController;
